// extracted by mini-css-extract-plugin
export default {"container":"ProgressBar_container__bkBCr","bar":"ProgressBar_bar__19WvV"};